<template>
		<div class="campaign-information-wrapper">
				<form action="#"
				      @submit.prevent="submitForm"
				      class="form"
				      ref="form"
				>
						<div class="row">
								<div class="col-sm-12" v-if="showTitle">
										<h3 class="text-left text-normal">
												Campaign Information
										</h3>
								</div>
								<div class="col-sm-12">
								<p class="info-text"> Fill out your campaign information </p>
								</div>
								<div class="col-sm-12">
										<div class="text-left text-danger" v-if="errors.has('internalError')">
												There was an error processing your campaign information. Please try again later.
										</div>
								</div>
						</div>

						<div class="margin-top-30 margin-bottom-20">
								<div class="row">
										<div class="form-group col-sm-12">
												<input-label type="text" css-class="form-control" v-model="formData.name"
												             placeholder="Campaign Name" required />
												<div class="invalid-feedback-red" v-if="errors.has('name')">
														{{errors.get('name')}}
												</div>
										</div>
								</div>

								<div class="row">
										<div class="form-group col-xs-12">
										<label class="hh-input-label">Campaign Category</label>
												<div class="hh-input-label-wrapper">
														<div class="hh-select" :class="formData.category ? 'hh-label-active' : ''">
																<v-select :options="staticData.categories"
																          v-model="formData.category"
																          required
																		  placeholder="Select your category"
																/>
														</div>
														
												</div>
												<div class="invalid-feedback-red" v-if="errors.has('category_code')">
														{{errors.get('category_code')}}
												</div>
										</div>
								</div>

								<div class="row">
										<div class="form-group col-xs-12">
												<label class="hh-input-label">Enter your goal amount</label>
												<currency-input class="currency-input" v-model="formData.goal_amount" required/>
												<div class="invalid-feedback-red" v-if="errors.has('goal_amount')">
														{{errors.get('goal_amount')}}
												</div>
										</div>
								</div>

								<div class="row">
									<div class="form-group col-sm-12">
											<label class="hh-input-label">Add your campaign details</label>
											<text-editor v-model="formData.campaign_blurb" required/>

											<div class="invalid-feedback-red" v-if="errors.has('campaign_blurb')">
													{{errors.get('campaign_blurb')}}
											</div>
									</div>
								</div>

								<div class="row margin-top-20 margin-bottom-20">
									<div class="upload-image-section" ref="uploadImage">
										<div class="col-md-12 upload-image-container">
											<div class="form-group">
												<label class="hh-input-label">Campaign Photos</label>
												<multiple-image-upload ref="campaignImagesComponent"
																	:images="formData.campaign_images"
																	@componentLoading="componentLoading"
																	@imagesUpdated="imagesUpdated"
																	imageType="campaign"
																	:endpoint="uploadCampaignImagesEndpoint"
																	field="campaign_image"
																	/>
											</div>
											<div class="invalid-feedback-red" v-if="errors.has('campaign_images')">
												{{errors.get('campaign_images')}}
											</div>
										</div>
									</div>
						    </div>

                <div class="row">
                  <div class="form-group col-xs-12">
                    <label class="hh-input-label">Enter the campaign end date</label>
                    <date-picker placeholder="02/22/2222" required v-model="formData.campaign_end_date" />
                    <div class="invalid-feedback-red" v-if="errors.has('campaign_end_date')">
                      {{errors.get('campaign_end_date')}}
                    </div>
                  </div>
                </div>

              <div class="creator-information-section margin-bottom-20">
                  <div class="row">
                    <h3 class="text-left text-normal margin-bottom-30 col-xs-12">
                        Campaign Organizer Information
                    </h3>
                    <p class="info-text col-xs-12"> Enter organizer information  </p>
                  </div>
                  <div class="row">
                      <div class="col-sm-6">
                          <input-label type="text" css-class="form-control" v-model="formData.contact_name"
                                       placeholder="Organizer Name" required />
                          <div class="invalid-feedback-red" v-if="errors.has('contact_name')">
                              {{errors.get('contact_name')}}
                          </div>
                      </div>
                      <div class="col-sm-6">
                          <input-label type="text" css-class="form-control" v-model="formData.campaign_contact"
                                       placeholder="Organizer Email Address" required />
                          <div class="invalid-feedback-red" v-if="errors.has('campaign_contact')">
                              {{errors.get('campaign_contact')}}
                          </div>
                      </div>
                  </div>

                <div class="row">
                  <div class="col-sm-6">
                    <div class="form-group">
                      <input-label type="text" css-class="form-control" v-model="formData.city"
                                   placeholder="City" required/>
                      <div>
                        <div class="invalid-feedback-red" v-if="errors.has('city')">
                          {{errors.get('city')}}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="form-group col-sm-6">
                    <div class="hh-input-label-wrapper">
                      <label class="hh-input-label">State</label>
                      <div class="hh-select" :class="formData.state ? 'hh-label-active' : ''">
                        <v-select :options="staticData.states"
                                  :value="formData.state"
                                  @input="setSelected"
                                  required
                                  id="states"
                        />
                      </div>

                    </div>
                    <div class="invalid-feedback-red" v-if="errors.has('state')">
                      {{errors.get('state')}}
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-12 form-group">
                    <div class="upload-image-section" ref="uploadImage">
                      <div class="upload-image-container">
                        <label class="hh-input-label">Campaign Organizer Logo (optional)</label>
                        <image-upload ref="logoComponent"
                                      :image-src="formData.logo_url"
                                      @componentLoading="componentLoading"
                                      @imageUpdated="logoUpdated"
                                      imageType="logo"
                                      :endpoint="logoEndpoint"
                                      size="small"
                                      field="logo"
                        />
                        <div class="invalid-feedback-red" v-if="errors.has('logo')">
                          {{errors.get('logo')}}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

              </div>
						</div>


				<div class="row hh-form-btn-wrapper margin-bottom-20 margin-top-20">
					<div class="form-group col-sm-6" v-if="editMode">
						<button type="button" v-on:click="cancelAction"
						        class="btn hh-btn back-btn btn-responsive" name="Cancel">
							Cancel
						</button>
					</div>
					<div class="form-group col-sm-6" v-if="editMode">
						<button type="submit" :disabled="loading" class="btn save-btn hh-btn-green" name="Save changes">
							Save Changes
						</button>
					</div>
					 <div class="form-group col-sm-6" v-if="!editMode">
						<button type="button"  @click="saveAsDraftAction"
										class="btn hh-btn" style="height: 56px; border: 2px solid #1DC071; color: #1DC071; background: white; width: 100%; font-family: Circular Std;
							font-size: 16px; line-height: 16px; text-align: center; color: #1DC071;" name="Save as draft">
										Save as Draft
							</button>
					</div>
					<div class="form-group col-sm-6" v-if="!editMode">
						<button type="submit" :disabled="loading"
						        class="btn save-btn hh-btn-green btn-responsive" name="Continue to donation amounts">
							Continue to Donation Amounts
						</button>
					</div>
				</div>
				</form>
		</div>
</template>

<script>
	import {mapGetters, mapActions} from 'vuex'
	import InputLabel from '../form/elements/InputLabel'
	import CurrencyInput from '../form/elements/CurrencyInput'
	import DatePicker from '../form/elements/DatePicker'
	import TextEditor from '../form/elements/TextEditor'
	import vSelect from 'vue-select'
	import MultipleImageUpload from '../form/MultipleImageUpload'
	import ImageUpload from '../form/ImageUpload'
	import { scrollTo } from '../../utils/componentHelper'
	import constants from '../../config'
	export default {
		name: 'CampaignInformation',

		components: {
			CurrencyInput,
			InputLabel,
			DatePicker,
			vSelect,
			TextEditor,
			MultipleImageUpload,
			ImageUpload,
		},

		props: {
			campaignData: Object,
      campaignImages: Object,
			staticData: {
				states: Object,
				categories: Object,
			},
			showTitle: {
				type: Boolean,
				default: true,
			},
			showSkipButton: {
				type: Boolean,
				default: true,
			},
			editMode: {
				type: Boolean,
				default: false,
			},
		},

		data: () => {
			return {
				loading: true,
				dataAnalysed: false,
				showTooltip: true,
				forceRecompute: 0,
				campaignSlug: null,
				componentsLoadingStatus: {
					ImageUpload: true,
					MultipleImageUpload: true,
				},
				
				formData: {
					informationType: 'campaign-information',
					method: 'post',
					withFiles: true,
					step: 1,
					campaign_images: [],
					state: null,
					category: null,
					category_code: null,
					logo_url: null,
					logo: null,
					goal_amount: 0,
					campaign_end_date: null,
					campaign_blurb: null,
				},
			}
		},

		beforeMount() {
			this.formData = { ...this.formData, ...this.campaignData }
      if (this.campaignImages) {
        this.formData.campaign_images = Object.values(this.campaignImages)
      }

			this.loading = false
			this.formData.goal_amount = _.toNumber(this.formData.goal_amount)
			this.campaignSlug = this.campaignData.slug
			this.formData.campaign_blurb = this.campaignData.campaign_blurb
		},

		mounted() {
			setTimeout(() => {
				this.showTooltip = false;
			}, 3000);
		},

		methods: {
			...mapActions('campaign', ['storeInformation', 'saveAsDraft']),

			cancelAction() {
				window.location = '/dashboard'
			},

			backAction () {
				this.$emit('navigateBack')
			},

			skipAction () {
				this.$emit('navigateNext')
			},

			setSelected(value) {
				this.formData.state = value
			},

			componentLoading (componentName, value) {
				this.componentsLoadingStatus[componentName] = value
			},

			imagesUpdated(images) {
				this.formData.campaign_images = images
			},

			logoUpdated(image_url, image) {
				this.logo_url = image_url
				this.formData.logo = image
			},


			submitForm() {
				this.loading = true
				this.formData.campaignSlug = this.campaignSlug
				this.formData.category_code = this.formData.category ? this.formData.category.code : null

        if (this.campaignSlug) {
          this.formData.campaign_images = null
        }

				this.storeInformation(this.formData).then(() => {
					this.forceRecompute++
					this.loading = false

					if (this.status === 'success') {
						this.analyseResponseData()
						this.$emit('formSubmitted')
					} else {
						scrollTo(this.$refs['form'])
					}

				})
			},

			analyseResponseData() {
				if (this.storeInformationData.attributes != null
					&& this.storeInformationData.attributes.slug != null
					&& this.storeInformationData.attributes.slug !== this.campaignSlug) {
					this.$router.push(`/campaign/create/${this.storeInformationData.attributes.slug}`)
				} else {
					this.$emit('formSubmitted')
				}
			},

			saveAsDraftAction() {
				this.loading = true
				this.formData.campaignSlug = this.campaignSlug
				this.formData.category_code = this.formData.category ? this.formData.category.code : null

        if (this.campaignSlug) {
          this.formData.campaign_images = null
        }

				this.storeInformation(this.formData).then(() => {
					this.forceRecompute++
					this.loading = false

					if (this.status === 'success') {
						this.$emit('formSubmitted')
						this.saveAsDraft(this.storeInformationData.attributes.slug).then(() => {
						this.forceRecompute++;
						this.cancelAction();

						})
					} else {
						scrollTo(this.$refs['form'])
					}
				})
			},
		},

		computed: {
			isDataFetched () {
				return !_.isEmpty(this.campaignData)
			},

			storeInformationData: {
				get () {
					return this.$store.getters['campaign/storeInformationData'](this.campaignSlug, this.formData.informationType, this.forceRecompute)
				},
			},

			status: {
				get () {
					return this.$store.getters['campaign/storeInformationStatus'](this.campaignSlug, this.formData.informationType, this.forceRecompute)
				},
			},

			errors: {
				get () {
					return this.$store.getters['campaign/storeInformationErrors'](this.campaignSlug, this.formData.informationType, this.forceRecompute)
				},
			},

			isLoading() {
				for (let component in this.componentsLoadingStatus) {
					if (this.componentsLoadingStatus[component]) {
						return true
					}
				}

				return this.loading
			},

			isFormReady () {
				return !this.loading
			},

			logoEndpoint() {
				if (_.isEmpty(this.campaignSlug)) {
					return null
				}

				return `${constants.BASE_URL}campaign/${this.campaignSlug}/logo`
			},

			

			uploadCampaignImagesEndpoint() {
				if (_.isEmpty(this.campaignSlug)) {
					return null
				}

				return `${constants.BASE_URL}campaign/upload-image/${this.campaignSlug}`
			}
		},

		watch: {
			isLoading(to, from) {
				this.$emit('componentLoading', 'campaignComponent', to)
			}
		}
	}
</script>

<style scoped>
		.fade-enter-active, .fade-leave-active {
				transition: opacity .5s;
		}
		.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
				opacity: 0;
		}

		.input-group-addon {
			background-color: white !important;
		}

		h3 {
			font-family: Circular Std;font-style: normal;font-weight: 500;font-size: 20px;line-height: 14px;color: #000000;
		}

		.info-text {
			font-family: Circular Std;
			font-style: normal;
			font-weight: 450;
			font-size: 14px;
			line-height: 15px;color: #AEAEAE;		
		}

		.currency-input {
			font-family: Circular Std;
			font-style: normal;
			font-weight: 500;
			font-size: 20px;
			line-height: 25px;
			letter-spacing: -0.01em;
			color: #000000; background: #F5F5F6;
			border: 1px solid #E9E9EC;
			box-sizing: border-box;
			border-radius: 4px;
		}
</style>
